import type { Cart, VoucherCart } from '@booking/types/booking'

export const MBWAY_POLL_INTERVAL_MS = 2500
export const MBWAY_POLL_MAX_ATTEMPTS = 120

export function normalizeMbWayPhone(phoneRaw: string): string {
  return phoneRaw.trim()
}

export function shouldRebuildMbWayCart(cart: Cart | VoucherCart, hasFired: boolean): boolean {
  return cart.status === 'RESERVED' || hasFired
}

export function buildMbWaySuccessPath(cartId: string, flow?: string): string {
  const origin = typeof window !== 'undefined' ? window.location.origin : ''
  const pathname = typeof window !== 'undefined' ? window.location.pathname : ''
  const qs = new URLSearchParams()
  qs.set('cartId', cartId)
  qs.set('paymentMethod', 'mbway')
  if (flow) qs.set('flow', flow)
  return `${origin}${pathname}?${qs.toString()}`
}

export function buildMbWaySuccessRoute(slug: string, cartId: string, flow?: string): string {
  const qs = new URLSearchParams()
  qs.set('cartId', cartId)
  qs.set('paymentMethod', 'mbway')
  qs.set('stage', 'thankyou')
  qs.set('success', 'true')
  if (flow) qs.set('flow', flow)
  return `/${slug}?${qs.toString()}`
}
